export const MUMBAI_TOKEN_LIST = {
  name: 'KyberSwap Token List',
  keywords: ['kyberswap', 'dmmexchange'],
  timestamp: '2020-12-12T00:00:00+00:00',
  tokens: [
    {
      chainId: 80001,
      address: '0xFD1f9381Cb641Dc76Fe8087dbcf8ea84a2c77cbE',
      symbol: 'KNC',
      name: 'Kyber Network Crystal',
      decimals: 18,
    },
    {
      chainId: 80001,
      address: '0x19395624C030A11f58e820C3AeFb1f5960d9742a',
      symbol: 'ETH',
      name: 'Ether',
      decimals: 18,
    },
    {
      chainId: 80001,
      address: '0x2CeC76B26A8d96BF3072D34A01BB3a4edE7c06BE',
      symbol: 'USDC',
      name: 'USDC',
      decimals: 6,
    },
    {
      chainId: 80001,
      address: '0x064B91Bda6d178DfE03835de9450BFe78201c43F',
      symbol: 'USDT',
      name: 'USDT',
      decimals: 6,
    },
    {
      chainId: 80001,
      address: '0x5e2de02472aC02736b43054f095837725A5870eF',
      symbol: 'DAI',
      name: 'DAI',
      decimals: 18,
    },
    {
      chainId: 80001,
      address: '0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889',
      symbol: 'WMATIC',
      name: 'Wrapped Matic',
      decimals: 18,
    },
    {
      chainId: 80001,
      address: '0x02CBE6055F8aad745321f70d6aDD4711455c7F45',
      symbol: 'jEUR',
      name: 'Jarvis Synthetic Euro',
      decimals: 18,
      logoURI: 'https://i.imgur.com/92uhfao.png',
    },
    {
      chainId: 80001,
      address: '0x915E1f55eC2dc1524101ef44d4a0EebFe10Bc6bc',
      symbol: 'jGBP',
      name: 'Jarvis Synthetic British Pound',
      decimals: 18,
      logoURI: 'https://i.imgur.com/HS7BMfs.png',
    },
    {
      chainId: 80001,
      address: '0x2b7D8FB31676Ab02DA37a124Acfa726125b1B95b',
      symbol: 'jCHF',
      name: 'Jarvis Synthetic Swiss Franc',
      decimals: 18,
      logoURI: 'https://i.imgur.com/Fp31dDB.png',
    },
  ],
  version: {
    major: 0,
    minor: 0,
    patch: 0,
  },
}
